import { httpRequest } from "@/lib";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export type DashboardMetrics = {
    revenue: number;
    patientsCount: number;
    aiEngagements: number;
    appointmentsCount: number;
    noShowRate: number | null;
    churnRisk?: {
        low: number;
        medium: number;
        high: number;
        uncalculated: number;
    };
    aiGeneratedAppointments: number;
    aiPotentialRevenue: number;
    outOfHoursAppointments: number;
};

export type DashboardCharts = {
    labels: string[];
    datasets: {
        name: string;
        data: number[];
    }[];
};

export function useDashboard() {
    const metricsQuery = useQuery({
        queryKey: ["dashboard-metrics"],
        queryFn: async (): Promise<AxiosResponse<DashboardMetrics>> => {
            return await httpRequest.get(`/dashboard/metrics`);
        },
        keepPreviousData: true,
    });

    const chartsQuery = useQuery({
        queryKey: ["dashboard-charts"],
        queryFn: async (): Promise<AxiosResponse<DashboardCharts>> => {
            return await httpRequest.get(`/dashboard/charts`);
        },
        keepPreviousData: true,
    });

    return {
        metrics: metricsQuery.isError ? undefined : metricsQuery.data?.data,
        metricsError: metricsQuery.isError,
        metricsFetching: metricsQuery.isFetching,
        refetchMetrics: metricsQuery.refetch,
        metricsLoading: metricsQuery.isLoading,
        charts: chartsQuery.isError ? undefined : chartsQuery.data?.data,
        chartsError: chartsQuery.isError,
        refetchCharts: chartsQuery.refetch,
        chartsLoading: chartsQuery.isLoading,
    };
}
